module.exports = __webpack_public_path__ + "static/orthodontics01-48305d1e8e74699834afefefe9fbd577.jpg";